import React, { useState, useEffect, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Chip, CircularProgress, Container, Grid, LinearProgress, Tab, Tabs, Typography } from "@mui/material";
import bkstApi from "../../common/api";
import ConfigContext from "../../common/context/ConfigContext";
import Flavors from "../../common/component/flavor/Flavors";

export default function FlavorsPage(props) {
  const siteConfig = useContext(ConfigContext);

  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    bkstApi(`/site/${siteConfig.id}/content/flavors`).then((res) => {
      setContent(res.data.content);

      document.title = "Flavors";
      setLoading(false);

      window.scrollTo(0, 100);
    });
  }, []);

  if (loading) {
    return <LinearProgress />;
  } else {
    return (
      <Box py={6}>
        <Container maxWidth="md">
          <Box mb={4} textAlign="center" id="flavors">
            <Typography variant="h1" gutterBottom>
              Flavors
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              We offer an electic mix of flavor options
            </Typography>
          </Box>
        </Container>
        <Container maxWidth="lg">
          <Box id="flavors">{content.flavors && <Flavors flavors={content.flavors} fillings={content.fillings} />}</Box>
        </Container>
      </Box>
    );
  }
}
